import { css } from "@emotion/css";

const styles = {
  input: css`
    max-height: 40px;
  `,
};

export default styles;
